import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AppRouter } from './AppRouter';
export function App() {
  return <HelmetProvider data-id="element-0">
      <AppRouter data-id="element-1" />
    </HelmetProvider>;
}